import { MatTableDataSource } from '@angular/material/table';
import { Component, Input, OnInit } from '@angular/core';
import { Drug } from '../../../drug-management/models/drug';
import { ERToolService } from '../../services/er-tool.service';

import { MatDialog } from '@angular/material/dialog';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ToastService } from 'src/app/shared/services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import * as constants from 'src/app/config/app-constants';
import { ImportWizardSearchDrugComponent } from '../import-wizard-search-drug/import-wizard-search-drug.component';
import { routePaths } from 'src/app/config/app-constants';
import { Router } from '@angular/router';
import { EventEmitter, Output } from '@angular/core';
@Component({
    selector: 'search-drug-list',
    templateUrl: './search-drug-list.component.html',
    styleUrls: ['./search-drug-list.component.scss'],
    standalone: false
})
export class SearchDrugListComponent implements OnInit {
  displayedColumns = ['name', 'ndc', 'countryCode','source', 'system', 'strength', 'manufacturer', 'priority', 'requestor', 'age','action'];
  selectedRow:any;
  dataSource= new MatTableDataSource<Drug>();
  @Input() dataSourceId:number = 0;
  @Input() searchText: string;
  @Input()  permanentQuarantine = false;
  @Input() countryId:number = 0;
  @Output() countUpdated: EventEmitter<number> = new EventEmitter<number>();
  @Input() selectedSearchCriteria: any;
  @Input() selectedDrugNameType: number = 4;
    //#region Pagination properties
    totalRows: number = 0;
    currentPage: number = 1;
    pageSize: number = 5;
    pageSizeOptions: number[] = [5, 10, 20, 40, 50];
    //#endregion

  constructor(
    private erToolService: ERToolService,
    private ngxLoader: NgxUiLoaderService,
    private toastService: ToastService,
    private route: Router,
    private dialog: MatDialog) { }

  ngOnInit(): void {
    this.getDrugData();
  }

  handleInputChange(dataSourceId:number,searchText:any, countryId:number, permanentQuarantine:boolean){
    this.dataSourceId=dataSourceId;
    this.searchText = searchText;
    this.countryId = countryId;
    this.permanentQuarantine = permanentQuarantine
    if(searchText.length>0){

    }
    else{
      this.dataSource = new MatTableDataSource<Drug>();
    }


}
redirectToDetailsPage(rowId:any,dataSourceId:number){
  this.route.navigate([`/${routePaths.ER_TOOL}/drug-details`, rowId,dataSourceId,'']);
}

openImportWizardSearchDrug() {

  const dialogRef = this.dialog.open(ImportWizardSearchDrugComponent, {
    backdropClass: ['lgDialog'],
    disableClose: true,
    data: {
      dataSourceId:this.dataSourceId,
      searchText: this.searchText,
      countryId:this.countryId,
      selectedSearchCriteria: this.selectedSearchCriteria,
      drugNameType: this.selectedSearchCriteria?.value === 'drugName' ? this.selectedDrugNameType : undefined
    }
  });

}
  getDrugData(){
    if(this.searchText.length===0){
      return;
   }

    const isDrugNameCriteria = this.selectedSearchCriteria?.value === 'drugName';
    const startsWithSpecialCharacter = /^[^a-zA-Z0-9]/.test(this.searchText);
    const hasAlphanumericCharacter = /[a-zA-Z0-9]/.test(this.searchText);

    if (isDrugNameCriteria && startsWithSpecialCharacter && !hasAlphanumericCharacter) {
      return;
    }

    let searchKey = 'searchKey'
    this.ngxLoader.start(searchKey);
    this.erToolService.getSearchDrugDataV1(
      this.dataSourceId,
      this.searchText,
      this.selectedSearchCriteria,
      this.countryId,
      this.currentPage,
      this.pageSize,
      this.selectedSearchCriteria?.value === 'drugName' ? this.selectedDrugNameType : undefined

    ).subscribe((result)=>{

      this.dataSource.data = result.data.drugs;
      this.currentPage = result.data.currentPage
      this.totalRows = result.data.totalRows
      this.countUpdated.emit(this.totalRows);
      this.ngxLoader.stop(searchKey);
    },
    (error: HttpErrorResponse) => {
      this.ngxLoader.stop(searchKey);
      this.toastService.openToast(
        error.message,
        constants.ToastPanelType.error,
        2
      );
    })
  }


}
